import { ReactElement } from 'react';
import { Link } from '@melio/penny';
import { AccountingPlatformSlug } from '@melio/platform-api';

import { AccountingPlatformCard as AccountingPlatformCardCl } from '@/cl/components/AccountingPlatformCard/AccountingPlatformCard.component';
import { usePartnerConfig } from '@/hooks/partners';
import { usePlatformIntl } from '@/translations/Intl';

type Props = {
  onConnectedClicked: () => void;
  name: string;
  logo: ReactElement | null;
  isLoading: boolean;
  accountingPlatformSlug?: AccountingPlatformSlug;
};

export const AccountingPlatformErrorCard = ({
  name,
  logo,
  isLoading,
  accountingPlatformSlug,
  onConnectedClicked,
}: Props) => {
  const { formatMessage } = usePlatformIntl();
  const { partnerConfig } = usePartnerConfig();
  const buttons = [
    {
      text: formatMessage('widgets.accountingPlatform.card.buttons.connect'),
      onClicked: onConnectedClicked,
      isLoading,
    },
  ];

  const support = (
    <Link
      href={`mailto:${partnerConfig.supportEmail}`}
      variant="inline"
      label={formatMessage('widgets.accountingPlatform.card.links.support')}
      newTab
    />
  );

  const description = [formatMessage('widgets.accountingPlatform.card.type.error.type.invalidCredentials.description')];
  const error = formatMessage('widgets.accountingPlatform.card.type.error.type.invalidCredentials.alert', { support });

  return (
    <AccountingPlatformCardCl
      title={name}
      errorText={error}
      descriptionList={description}
      buttons={buttons}
      logo={logo}
      accountingPlatformSlug={accountingPlatformSlug}
    />
  );
};
